var map = {
	"./hp.svg": 274,
	"./print-os.svg": 275
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 574;



//////////////////
// WEBPACK FOOTER
// ./images ../~/html-loader!\.svg$
// module id = 574
// module chunks = 0